"use client";

import { ProjectCoverGlow } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/controls/modals/projectCover/ProjectCoverGlow";
import { ProjectCoverOrb } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/controls/modals/projectCover/ProjectCoverOrb";
import { AudimeeMark } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/controls/opening/AudimeeMark";
import { SmallTitle } from "@/components/text/SmallTitle";
import { SoftText } from "@/components/text/SoftText";

// The loading card itself: a cover with its glow (or, with no project to show, the Audimee mark), a name, a status line and ONE moving element, the sliding bar. The cover, the glow and the text hold still on purpose: a progress indicator does not share its surface with a second one. The card has no idea what it is waiting for; the route's loading state and the in-editor opening card hand it their own words.
export function TtvOpeningCardFrame({
  name,
  coverSeed,
  status,
}: {
  name: string;
  // The seed of the project's or template's cover; null for a card that stands for the product itself (the page-level loading state), which wears the Audimee mark instead.
  coverSeed: string | null;
  status: string;
}) {
  return (
    <div className="relative flex w-full max-w-sm flex-col items-center gap-4 overflow-hidden rounded-2xl bg-ttvCard px-7 pb-6 pt-7 shadow-floatingCard">
      {coverSeed === null ?
        <>
          <div className="absolute -left-12 -top-16 h-44 w-44 rounded-full bg-primary opacity-25 blur-2xl" />
          <AudimeeMark className="relative h-16 w-16 text-primaryLight" />
        </>
      : <>
          <ProjectCoverGlow
            seedText={coverSeed}
            className="absolute -left-12 -top-16 h-44 w-44 opacity-25 blur-2xl"
          />
          <ProjectCoverOrb
            seedText={coverSeed}
            className="relative h-16 w-16 rounded-[9%]"
          />
        </>
      }
      <div className="relative flex min-w-0 max-w-full flex-col items-center gap-1">
        <SmallTitle
          elementType="p"
          className="max-w-full truncate text-ttvValue"
        >
          {name}
        </SmallTitle>
        <SoftText
          elementType="p"
          className="text-xs font-light leading-4 text-ttvSubtle"
        >
          {status}
        </SoftText>
      </div>
      <div className="relative h-1 w-full overflow-hidden rounded-full bg-ttvRaised">
        <div className="h-full w-1/3 animate-progress-slide rounded-full bg-primary motion-reduce:animate-none" />
      </div>
    </div>
  );
}
